import { render, staticRenderFns } from "./EditorFormatLabSettingInput.vue?vue&type=template&id=00c8ac05&scoped=true&"
import script from "./EditorFormatLabSettingInput.vue?vue&type=script&lang=js&"
export * from "./EditorFormatLabSettingInput.vue?vue&type=script&lang=js&"
import style0 from "./EditorFormatLabSettingInput.vue?vue&type=style&index=0&id=00c8ac05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c8ac05",
  null
  
)

export default component.exports